import axios from 'axios'

export const HTTPgouv = axios.create({
  baseURL: `https://api-adresse.data.gouv.fr`,
  headers: {
    // Authorization: 'Bearer {token}'
  }
})

export const minuAPI = axios.create({
  baseURL: `https://minutiae.fr/api2/`,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})



// WEBPACK FOOTER //
// ./src/services/http-common.js